export enum Theme {
  PRIMARY = 'primary',
  LIGHT = 'light',
  TERTIARY = 'tertiary', // light green
  DARK = 'dark',
  SUCCESS = 'success',
  DANGER = 'danger',
  WARNING = 'warning',
}

export default Theme;
